export default __webpack_public_path__ + "0cc255909b7ddee8d0b536e497088808.woff";